// import { App } from "vue";
import request from "./request";
import Cookies from "js-cookie";
import { debounce } from "lodash";
import UAParser from "ua-parser-js";
import dayjs from "dayjs";
import store from "@/store";

// import { SearchType } from '@/store/modules/global-search'

// interface CommonParams {
//   // 固定秘钥，对应每个appId
//   secret: string
//   // 访问系统
//   appId: string
//   // 应用版本号：v0.0.4
//   appVersion: string
//   // 分辨率；如："1920*1080"
//   browserResolution?: string
//   // 浏览器，如：Chrome 8
//   browser?: string
//   // 浏览器版本，如：86.0.4240.198
//   browserVersion?: string
//   // 公⽹
//   publicIp?: string
//   // 局域⽹IP
//   lanIp?: string
//   // 城市名称
//   cityName?: string
//   // 省份
//   provinceName?: string
//   // 国家
//   countryName?: string
//   // 操作系统：Windows
//   os?: string
//   // 访问时间，如：2021-07-27 15:14:01
//   visitTime?: string
//   // 初始打开系统时，⽣成的，sessionId
//   sessionId?: string
//   // 浏览器userAgent
//   userAgent?: string
//   // 设备ID，移动端
//   deviceId?: string
//   // ⼿机imei，移动端
//   imei?: string
//   // mac 移动端
//   mac?: string
//   // IOS IDFA 移动端⼿
//   idfa?: string
//   // 品牌：移动端⼿机品牌
//   brand?: string
//   // ⼿机型号
//   version?: string
//   // ⼿机系统版本号3
//   versionNo?: string
//   // ⽹络：1-WiFi，2-2G,3-3G,4-4G,5-5G,5-6G
//   network?: string
//   // ⽹络运营商
//   netProvice?: string
//   // 数据写⼊时间
//   insertTime?: string
// }

// interface TrackingParams {
//   // 应⽤ID
//   appId?: string
//   // 应⽤名称
//   appName?: string
//   // 初始打开系统时，⽣成的，sessionId
//   sessionId?: string
//   // ⽤户Id
//   userId?: string
//   // 事件ID
//   eventCode: 'click' | 'play' | 'view'
//   // 事件名称
//   eventName?: string
//   // 事件时⻓
//   eventTimes?: number
//   // 访问时间，2022-5-13 17:00:01
//   visitTime?: string
//   // 离开时间，格式：2022-5-13 17:00:37
//   leaveTime?: string
//   // 事件上下⽂，Json串:参数⻅：eventCon
//   eventContext?: EventContext
//   // 资源码
//   rsCode: string
//   // 资源名称
//   rsName: string
//   // 数据写⼊时间
//   insertTime?: string
// }

// export interface EventContext {
//   // 品牌编码
//   brandId?: string
//   // 品牌名称
//   brandName?: string
//   // 默认状态:0-否，1-是
//   defaultStatus?: '0' | '1'
//   //媒体类型:1 视频 2 图⽚ 3 ⾳频
//   mediumType?: '1' | '2' | '3'
//   // 媒体数据ID（数据库⾏ID）
//   mediumId?: string
//   // 媒体名称
//   mediumName?: string
//   // 完成状态:0-否，1-是
//   completeStatus?: '0' | '1'
//   // ota版本功能ID
//   otaVersionFuncId?: string
//   // ota版本功能名称
//   otaVersionFuncName?: string
//   // ota版本号
//   otaVersionNo?: string
//   // 功能⼤类ID
//   otaVerFuncClaLevelOneId?: string
//   // 功能⼤类名称
//   otaVerFuncClaLevelOneName?: string
//   // 上一级功能ID
//   otaVerFuncLastClaLevelId?: string
//   // 上一级功能名称
//   otaVerFuncLastClaLevelName?: string
//   // ⼦⻋型ID
//   subModelId?: string | number
//   // ⼦⻋型名称
//   subModelName?: string
//   // 子车型型号ID
//   subModelVersionId?: string
//   // 子车型型号名称
//   subModelVersionName?: string
//   // 上⼀级资源码
//   preRsCode?: string
//   // 上⼀级资源名称
//   preRsName?: string
//   // 层级
//   level?: string
//   // 叶⼦状态:0-否，1-是
//   leafStatus?: '0' | '1'
//   // 登录⽅式:1-密码，2-验证码
//   loginType?: string
//   // 登录状态:0-失败，1-成功
//   loginStatus?: '0' | '1'
//   // 登录失败原因
//   loginError?: string
//   // Tab名称
//   tabName?: string
//   // 页面名称
//   pageName?: string
//   // 全局搜索联想结果类型
//   searchType?: SearchType
//   // 搜索关键词
//   searchLabel?: string
//   // ota 月报 id
//   otaReportId?: number
//   // ota 月报名称
//   otaReportName?: string
//   waysFuncId?: string | number
//   waysFuncName?: string
//   // 会员版本id
//   memberVersion?: VipVersion
//   // 配置弹窗id
//   popupId?: string
// }

const trackingIdKey = "TRACKING_ID";
const sessionId = { value: "" };
export const buryPointTimeFormat = "YYYY-MM-DD HH:mm:ss";
// 注册埋点
const registBuryPoint = async (timeoutId) => {
  let trackingId = Cookies.get(trackingIdKey);
  if (trackingId === "undefined" || timeoutId === trackingId) {
    trackingId = undefined;
  }
  if (trackingId) {
    sessionId.value = trackingId;
  } else {
    const { version } = (await import("../../package.json")).default;
    const { screen } = window;
    const uaData = new UAParser().getResult();
    const commonParams = {
      secret: process.env.VUE_APP_SECRET,
      appId: process.env.VUE_APP_APPID,
      appVersion: version,
      browserResolution: `${screen.width}*${screen.height}`,
      browser: uaData.browser.name,
      browserVersion: uaData.browser.version,
      os: `${uaData.os.name} ${uaData.os.version}`,
      visitTime: dayjs().format(buryPointTimeFormat),
      userAgent: uaData.ua,
    };

    // get session id
    const data = await request({
      url: "/tracking/register",
      method: "post",
      data: {
        data: {
          ...commonParams,
        },
      },
      baseURL: "",
    });
    sessionId.value = data?.data?.data?.sessionId;
    if (sessionId.value) {
      Cookies.set(trackingIdKey, sessionId.value);
    } else {
      Cookies.remove(trackingIdKey);
    }
  }
};

const debounceRegist = debounce(() => {
  registBuryPoint(sessionId.value);
}, 1000);

// 发送埋点信息
const sentBuryPointInfo = async (trackingInfo) => {
  const userId = store.getters.user.userId;
  if (sessionId.value) {
    const data = await request({
      url: "/tracking/tracking",
      method: "post",
      data: {
        data: {
          sessionId: sessionId.value,
          userId,
          visitTime: dayjs().format(buryPointTimeFormat),
          eventContext: {
            url: window.location.pathname,
          },
          ...trackingInfo,
        },
      },
      baseURL: "",
    });
    if (!data?.data?.data?.success) {
      debounceRegist();
    }
  }
};

// 验证是否是https开头
const verifyHttpsStart = (path, val) => {
  // if (path.startsWith("https")) {
  //   const index = path.indexOf("?");
  //   if (index !== -1) {
  //     return path.slice(0, index);
  //   }
  // }
  // 过滤数据
  const index = val?.length;
  if (index !== -1 && path.indexOf("?") !== -1) {
    return path.slice(0, index);
  }
  return path;
};

// 顶级或子集埋点菜单参数处理
const menuParameterDisp = (path) => {
  const microAppRoutes = store.getters.microAppRoutes;
  let parameter = null; // 埋点请求参数获取
  // 寻找点击的值是否是第一级
  const findVal = microAppRoutes.find(
    (find) => find.path === verifyHttpsStart(path, find.path) && find.type === 0
  );
  let objVal = { rsName: [], rsCode: [], rsName1: [], rsCode1: [] };
  const filterFn = (item, bl = true) => {
    if (item.children && item.children.length) {
      if (bl) {
        item.children.forEach((item2) => {
          objVal.rsName.push(item2.title);
          objVal.rsCode.push(item2.id);
          if (verifyHttpsStart(path, item2.path) === item2.path) {
            const leng = objVal.rsName.length;
            const leng1 = objVal.rsName1.length;
            objVal.rsName.splice(
              1,
              leng > 2 ? 1 : 0,
              objVal.rsName1[leng1 - 1]
            );
            objVal.rsCode.splice(
              1,
              leng > 2 ? 1 : 0,
              objVal.rsCode1[leng1 - 1]
            );
            parameter = {
              rsName: objVal.rsName.join("-"),
              rsCode: objVal.rsCode.join("-"),
            };
          }
          if (!parameter && item2.path === "#") {
            objVal.rsName1.push(item2.title);
            objVal.rsCode1.push(item2.id);
          }
          if (!parameter) filterFn(item2);
        });
      } else {
        if (parameter) return;
        objVal.rsName.push(item.children[0].title);
        objVal.rsCode.push(item.children[0].id);
        filterFn(item.children[0], false);
      }
    } else {
      if (bl) {
        objVal.rsName = [objVal.rsName[0]];
        objVal.rsCode = [objVal.rsCode[0]];
      } else {
        parameter = {
          rsName: objVal.rsName.join("-"),
          rsCode: objVal.rsCode.join("-"),
        };
      }
    }
  };
  if (findVal) {
    objVal.rsName = [findVal.title];
    objVal.rsCode = [findVal.id];
    filterFn(findVal, false);
  } else {
    // 点击了子集
    microAppRoutes.forEach((item) => {
      objVal.rsName = [item.title];
      objVal.rsCode = [item.id];
      if (!parameter) filterFn(item);
    });
  }
  return parameter;
};

const initBuryPoint = async () => {
  // 注册埋点
  await registBuryPoint().catch((e) => {
    console.error(e);
  });
};

export { initBuryPoint, sentBuryPointInfo, menuParameterDisp };
